import { FindPersonalAccidentQuoteParams } from '@apis/PersonalAccidentQuoteApi';
import { getRoute } from '@utils/route';

export type PersonalAccidentQuoteDetailsPageParams = FindPersonalAccidentQuoteParams

export const PERSONAL_ACCIDENT_QUOTE_DETAILS_ROUTE_URL = '/personal-accident-insurance-quote-details/*';
export const PERSONAL_ACCIDENT_QUOTE_DETAILS_PAGE_URL = '/personal-accident-insurance-quote-details';
export const PERSONAL_ACCIDENT_QUOTE_SEND_MAIL_PAGE = '/personal-accident-insurance-quote-details/send-email';

export const routePersonalAccidentQuoteDetailsPage = (searchParams: PersonalAccidentQuoteDetailsPageParams) => getRoute(PERSONAL_ACCIDENT_QUOTE_DETAILS_PAGE_URL, { searchParams });
export const routePersonalAccidentQuoteSendEmailPage = (searchParams: PersonalAccidentQuoteDetailsPageParams) => getRoute(PERSONAL_ACCIDENT_QUOTE_SEND_MAIL_PAGE, { searchParams });
